import React, { useState, FunctionComponent, useCallback, FormEvent, ChangeEvent } from "react";
import NewsletterLineItem from "components/v3/newsletter-management/line-item/NewsletterLineItem";
import TextInput from "components/v3/text-input/TextInput";
import TermsAndPrivacyPolicyContainer from "containers/v3/TermsAndPrivacyPolicyContainer";
import { THEMES } from "common/constants/Constants";
import SubmitError from "../submit-error/SubmitError";
import { PrimaryButton } from "bb.lego-ui";
import styles from "./styles.module.scss";

export interface StandaloneNewsletterProps {
    country?: string;
    newsletter: InternalNewsletter;
    email?: string;
    errorMessage?: string;
    thinking?: string;
}

export interface StandaloneNewsletterFunctions {
    fetchNewsletterData: (email?: string) => void;
    updateSubscriptions: (subscriptions: Record<string, boolean>, email: string) => Promise<void>;
}

export type ConnectedProps = StandaloneNewsletterProps & StandaloneNewsletterFunctions;

const StandaloneNewsletter: FunctionComponent<ConnectedProps> = (props) => {
    const {
        country,
        email: initialEmail,
        newsletter,
        updateSubscriptions,
        errorMessage,
        thinking
    } = props;
    const [ email, setEmail ] = useState(initialEmail);

    const updateEmail = useCallback((e: ChangeEvent<HTMLInputElement>) => setEmail(e.target.value), [setEmail]);
    const onSubmit = (e: FormEvent<HTMLFormElement>): Promise<void> | undefined => {
        e.preventDefault();

        if (!newsletter.list) {
            return;
        }

        return updateSubscriptions({ [(newsletter.list)]: true }, email as string);
    };

    if (!newsletter.title) {
        return (
            <main className={ styles.container }>
                <span>Loading...</span>
            </main>
        );
    }

    return (
        <main>
            <div className={ styles.container } selectid="newsletter-signup-form">
                { errorMessage && <SubmitError error={ { message: errorMessage } } theme={ THEMES.ERROR_THEME_MODULE_LEVEL } /> }
                <form className={ styles.form } onSubmit={ onSubmit }>
                    <NewsletterLineItem
                        key={ newsletter.title }
                        list={ newsletter.list }
                        description={ newsletter.description as string }
                        title={ newsletter.title }
                        theme={ newsletter.theme }
                        sampleUrl={ newsletter.sampleUrl }
                        userNewsletters={ [] }
                        showCheckbox={ false }
                    />
                    <div className={ styles.input }>
                        <TextInput
                            name="email"
                            type="email"
                            placeholder="Enter your email"
                            value={ email }
                            onChange={ updateEmail }
                            disabled={ false }
                            autoFocus={ true }
                        />
                        <TermsAndPrivacyPolicyContainer country={ country } isForAccountCreation={ false } />
                        <div className={ styles.submit }>
                            <PrimaryButton disabled={ !email } type="submit" fullWidth={ true } loading={ !!thinking }>
                                Sign Up
                            </PrimaryButton>
                        </div>
                    </div>
                </form>
            </div>
        </main>
    );
};

export default StandaloneNewsletter;
